import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "./Carousel.css";
import { useTranslation } from "react-i18next";
import {
  carousel1,
  carousel1Mobile,
  carouselBottom1,
  carouselBottom2,
  carouselBottom3,
  carouselBottom4,
  carouselBottom5,
  carouselIcon1,
  productBg,
} from "../../../assets/images";
import axios from "axios";
import { Link } from "react-router-dom";

const Carousel = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex2, setActiveIndex2] = useState(0);
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
   const [list, setItems] = useState([]);
   const [list2, setItems2] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

    useEffect(() => {
      getProducts();
    }, []);
  
   const getProducts = async () => {
  try {
    const response = await axios.get(
      `https://www.elzabeauty.az/elza/dashboard.php`,
      { withCredentials: false }
    );

    let products = response.data.data || [];

    // Array-i qarışdır (Fisher–Yates Shuffle)
    const shuffleArray = (arr) => {
      let array = [...arr];
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    const shuffled = shuffleArray(products);

    setItems(shuffled.slice(0, 5)); // random 5
    setItems2(shuffled.slice(5, 7)); // random 2 (daha əvvəl seçilməyənlər)

  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

 
  const slides = [
    {
      img: productBg,
      mobileImg: productBg,
      text: "Təbii Gözəllik, Elza Beauty ilə",
      content:
        "Keyfiyyətli kosmetik məhsullar və professional kiprik kolleksiyası",
    },
  ];

  const cities = [
    { id: 1, image: carouselBottom1 },
    { id: 2, image: carouselBottom2 },
    { id: 3, image: carouselBottom3 },
    { id: 4, image: carouselBottom4 },
    { id: 5, image: carouselBottom5 },
  ];

  const cities2 = [
    { id: 1, image: carouselBottom1 },
    { id: 2, image: carouselBottom2 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex2((prevIndex) => (prevIndex + 1) % 4);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 500);

    const buttonTimer = setTimeout(() => {
      setShowButton(true);
    }, 1500);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, [activeIndex]);

  return (
    <div className="w-full mx-auto">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        onSlideChange={(swiper) => {
          setShowText(false);
          setShowButton(false);
          setActiveIndex(swiper.activeIndex);
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative">
              <img
                src={slide.img}
                alt={`Slide ${index + 1}`}
                className="w-full md:h-[757px] h-[600px] object-cover hidden md:inline-block"
              />
              <img
                src={slide.mobileImg}
                alt={`Slide ${index + 1}`}
                className="w-full h-[780px] object-cover md:hidden"
              />
              {activeIndex === index && (
                <div className="absolute inset-0 flex flex-col justify-center items-center lg:items-start text-white p-4 lg:px-7 transition-opacity duration-1000">
                  <div className="md:w-[890px] relative mx-auto text-center">
                    <div>
                      <p
                        className={`font-firstFont text-[24px] pt-[55px] md:pt-24 md:text-[56px] text-[#181D27] transition-all duration-1000 transform ${
                          showText
                            ? "translate-y-0 opacity-100"
                            : "-translate-y-10 opacity-0"
                        }`}
                      >
                        {t(slide.text)}
                      </p>
                      <p
                        className={`text-[14px] md:text-[16px] md:w-[384px] mx-auto text-[#181D27] transition-all duration-1000 transform ${
                          showText
                            ? "translate-y-0 opacity-100"
                            : "-translate-y-10 opacity-0"
                        }`}
                      >
                        {t(slide.content)}
                      </p>
                    </div>

                    <div className="flex justify-center mt-[80px] md:mt-[100px]">
                      <a
                        className="w-full md:w-[209px]"
                        href={`/${currentLanguage}/products`}
                      >
                        <div className="flex items-center justify-center bg-[#181D27] h-[52px] text-white rounded-lg w-full md:w-[209px] transition-all duration-300 ease-in-out transform hover:scale-105 shadow-md hover:shadow-xl">
                          <div className="flex items-center justify-center">
                            <div>{t("Məhsullara Bax")}</div>
                            <img className="w-6 h-6 ml-3" src={carouselIcon1} />
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="hidden md:flex justify-center mt-[80px]">
                      <div className="backdrop-blur-2xl bg-white/30 rounded-lg shadow-lg w-full max-w-[896px] h-[184px] px-10 py-5 flex items-center gap-8">
                        {list.map((item, index) => (
                          <div
                            key={item.id}
                            className={`w-[180px] h-[144px] transition-all duration-500 ${
                              activeIndex2 === index ? "scale-110" : "scale-100"
                            }`}
                          >
                                                      <a href={`/${currentLanguage}/product-detail/${item.id}`}>
                            <img
                              src={`https://www.elzabeauty.az/elza/${item.image1}`}
                              alt={`city-${item.id}`}
                              className="w-full h-full object-cover"
                            />
                                                      </a>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex flex-col justify-center mx-auto md:hidden mt-[115px] w-full">
                      <div className="backdrop-blur-2xl px-5 py-4 rounded-lg">
                        <div className="flex items-center gap-10 justify-center">
                          {list2.map((item, index) => (
                            <div
                              key={item.id}
                              className={`w-[120px] h-[96px] transition-all duration-500 ${
                                activeIndex2 === index
                                  ? "scale-125"
                                  : "scale-100"
                              }`}
                            >
                              <a href={`/${currentLanguage}/product-detail/${item.id}`}>
                              <img
                              src={`https://www.elzabeauty.az/elza/${item.image1}`}
                              alt={`city-${item.id}`}
                              className="w-full h-full object-cover"
                            />
                            </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
